module.exports = __webpack_public_path__ + "static/media/irritated-annoyed.04084a06.png";